module.exports = __webpack_public_path__ + "img/santa-claus-avatar.0a1092a7.svg";